import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { AuthGuard } from "../app/services/auth.guard";
import { DefaultComponent } from './layouts/default/default.component';
import { LoginComponent } from './login/login.component';
import { DashboardComponent } from './modules/dashboard/dashboard.component';
import { NovoFornecedorComponent } from './modules/novo-fornecedor/novo-fornecedor.component';
import { RefreshComponent } from './modules/refresh/refresh.component';
import { ConsultarFornecedorComponent } from './modules/consultar-fornecedor/consultar-fornecedor.component';
import { NovoProdutoComponent } from './modules/novo-produto/novo-produto.component';
import { NovoGrupoComponent } from './modules/novo-grupo/novo-grupo.component';
import { ConsultarGrupoComponent } from './modules/consultar-grupo/consultar-grupo.component';
import { ConsultarProdutoComponent } from './modules/consultar-produto/consultar-produto.component';
import { NovoUnidadeMedidaComponent } from './modules/novo-unidade-medida/novo-unidade-medida.component';
import { ConsultarUnidadeMedidaComponent } from './modules/consultar-unidade-medida/consulta-unidade-medida.component';
import { ConsultarClienteComponent } from './modules/consultar-cliente/consultar-cliente.component';
import { NovoClienteComponent } from './modules/novo-cliente/novo-cliente.component';
import { NovoFuncionarioComponent } from './modules/novo-funcionario/novo-funcionario.component';
import { ConsultarFuncionarioComponent } from './modules/consultar-funcionario/consultar-funcionario.component';
import { SolicitacoesCadastroComponent } from './modules/solicitacoes-cadastro/solicitacoes-cadastro.component';
import { ConsultarPedidoComponent } from './modules/consultar-pedidos/consultar-pedidos.component';
import { ValoresMinimosComponent } from './modules/valores-minimos/valores-minimos.component';
import { RelatorioVendasComponent } from './modules/relatorio-vendas/relatorio-vendas.component';
import { RelatorioComissaoComponent } from './modules/relatorio-comissao/relatorio-comissao.component';
import { NovaCidadeComponent } from './modules/nova-cidade/nova-cidade.component';
import { RelatorioMercadoriasVendidasComponent } from './modules/relatorio-mercadorias-vendidas/relatorio-mercadorias-vendidas.component';
import { GerenciarPromocoesComponent } from './modules/gerenciar-promocoes/gerenciar-promocoes.component';
import { FecharComissaoComponent } from './modules/fechar-comissao/fechar-comissao.component';
import { RelatorioEstoqueComponent } from './modules/relatorio-estoque/relatorio-estoque.component';
import { RelatorioAcessosComponent } from './modules/relatorio-acessos/relatorio-acessos.component';
// import { ValidarEstoqueComponent } from './modules/validar-estoque/validar-estoque.component';
import { MapaRotasComponent } from './modules/mapa-rotas/mapa-rotas.component';
import { ControleEstoqueComponent } from './modules/controle-estoque/controle-estoque.component';
import { ErroCadastroLatLngComponent } from './modules/erro-cadastro-lat-lng/erro-cadastro-lat-lng.component';
import { RelatorioPromocoesClientesComponent } from './modules/relatorio-promocoes-clientes/relatorio-promocoes-clientes.component';
import { RelatorioBoletosComponent } from './modules/relatorio-boletos/relatorio-boletos.component';
import { RelatorioMovimentacaoEstoqueComponent } from './modules/relatorio-movimentacao-estoque/relatorio-movimentacao-estoque.component';
import { RelatorioPagamentosComponent } from './modules/relatorio-pagamentos/relatorio-pagamentos.component';
import { VincularPromocaoLoteClientesComponent } from './modules/vincular-promocao-lote-clientes/vincular-promocao-lote-clientes.component';
import { SolicitacoesExclusaoDadosComponent } from './modules/solicitacoes-exclusao-dados/solicitacoes-exclusao-dados.component';
import { AdicionarCreditoComponent } from './modules/adicionar-credito/adicionar-credito.component';
import { GerarBoletoComponent } from './modules/gerar-boleto/gerar-boleto.component';
import { ManutencaoLojaComponent } from './modules/manutencao-loja/manutencao-loja.component';
import { GerenciarEstoqueComponent } from './modules/gerenciar-estoque/gerenciar-estoque.component';
// import { RecuperarSenhaComponent } from './recuperar-senha/recuperar-senha.component';

const routes: Routes = [
  { path: '', component: LoginComponent },
  { path: 'login', component: LoginComponent },
  {
    path: 'pages',
    component: DefaultComponent,
    children: [
      {
        path: 'refresh',
        component: RefreshComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'dashboard',
        component: DashboardComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'consultar-pedidos',
        component: ConsultarPedidoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'solicitacoes-cadastro',
        component: SolicitacoesCadastroComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'novo-fornecedor',
        component: NovoFornecedorComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'novo-produto',
        component: NovoProdutoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'novo-grupo',
        component: NovoGrupoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'novo-unidade-medida',
        component: NovoUnidadeMedidaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'novo-cliente',
        component: NovoClienteComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'novo-funcionario',
        component: NovoFuncionarioComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'nova-cidade',
        component: NovaCidadeComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'consultar-fornecedor',
        component: ConsultarFornecedorComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'consultar-grupo',
        component: ConsultarGrupoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'consultar-produto',
        component: ConsultarProdutoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'consultar-produto',
        component: ConsultarUnidadeMedidaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'consultar-unidade-medida',
        component: ConsultarUnidadeMedidaComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'consultar-cliente',
        component: ConsultarClienteComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'consultar-funcionario',
        component: ConsultarFuncionarioComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'valores-minimos',
        component: ValoresMinimosComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorio-vendas',
        component: RelatorioVendasComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorio-comissao',
        component: RelatorioComissaoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorio-mercadorias-vendidas',
        component: RelatorioMercadoriasVendidasComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'gerenciar-promocoes',
        component: GerenciarPromocoesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'fechar-comissao',
        component: FecharComissaoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorio-estoque',
        component: RelatorioEstoqueComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorio-acessos',
        component: RelatorioAcessosComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorio-pagamentos',
        component: RelatorioPagamentosComponent,
        canActivate: [AuthGuard],
      },
      // {
      //   path: 'validar-estoque',
      //   component: ValidarEstoqueComponent,
      //   canActivate: [AuthGuard],
      // },
      {
        path: 'mapa-rotas',
        component: MapaRotasComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'erro-cadastro-lat-lng',
        component: ErroCadastroLatLngComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorio-promocoes-clientes',
        component: RelatorioPromocoesClientesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorio-movimentacao-estoque',
        component: RelatorioMovimentacaoEstoqueComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorio-boletos',
        component: RelatorioBoletosComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'adicionar-credito',
        component: AdicionarCreditoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'gerar-boleto',
        component: GerarBoletoComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'vincular-promocao-lote-clientes',
        component: VincularPromocaoLoteClientesComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'solicitacoes-exclusao-dados',
        component: SolicitacoesExclusaoDadosComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'entrada-saida-estoque',
        component: ControleEstoqueComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'gerenciar-estoque',
        component: GerenciarEstoqueComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'manutencao-loja',
        component: ManutencaoLojaComponent,
        canActivate: [AuthGuard],
      },
    ]
  },
];

const config: ExtraOptions = {
  useHash: true,
};

@NgModule({
  imports: [RouterModule.forRoot(routes, config)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
